<template>
  <Modal
    @close="setCloseModal"
    :show="showModal">
    <h1 slot="header">
      <span v-if="theCreateCalendarsType === 'merge'">{{ $t('vue2.createmerge.create_merge') }}</span>
      <span v-if="theCreateCalendarsType === 'other'">{{ $t('vue2.create_calendars.other_calendar') }}</span>
      <span v-if="theCreateCalendarsType === 'room'">{{ $t('vue2.createrooms.create_rooms') }}</span>
      <span v-if="theCreateCalendarsType === 'club'">{{ $t('vue2.club.create_club_calendar') }}</span>
      <span v-if="theCreateCalendarsType === 'kindergarten'">Opret stuer</span>
    </h1>
    <div slot="body">
      <h3 class="flex align-center marg-1-bottom" v-if="calendarTypeIsWithSchoolYear">
        <template v-if="!isKindergarten">{{ $t('vue2.createklass.schoolyear') }}</template>
        <template v-else>Periode</template>
        <ChangeSchoolYear :whiteTheme="true" class="marg-1-left"></ChangeSchoolYear>
      </h3>
      <div class="cr-content">
        <h3 class="modal-form__titles">{{ $t('vue2.createmerge.name') }}</h3>
        <div class="modal-form-group" v-for="cal in calendars">
          <div class="flex create-form">
            <div>
              <input type="text"
                     :placeholder="placeholderText"
                     class="namefield"
                     :class="{'missing-input': cal.isSameName}"
                     v-model="cal.name"
                     @keyup="checkAllForText"
              />
            </div>
          </div>
          <div class="delete__user" @click="removeCalendar(cal)">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div>
          <div class="add-more-button" @click="pushNewCalendar">
            <span class="plus--icon">
              +
            </span>
            <span class="add-more-button__text"> {{ $t('vue2.createusers.add_more') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer"
         class="flex flex-end pad-10">
      <p v-if="someWithSameName" class="error-message marg-20-right warning-text">
        {{ $t('vue2.createmerge.warning_text') }}</p>
      <!-- Inactive button -->
      <button v-if="showInactiveButton"
              class="submit-btn--disabled">
        {{ $t('vue2.createusers.create') }}
      </button>
      <!-- Uni-Login Create button -->
      <button class="submit-button" v-else
              @click="submit">
        {{ buttonText }}
      </button>
    </div>
  </Modal>
</template>

<script>
import Modal from './Modal'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import ChangeSchoolYear from '../School/ChangeSchoolYear'

export default {
  components: {ChangeSchoolYear, Modal},
  data () {
    return {
      showModal: false,
      calendars: [],
      calendarsWithText: [],
      someWithSameName: false,
      openedFromRoRSelect2: false
    }
  },
  computed: {
    isKindergarten () {
      return this.$store.getters.isKindergarten
    },
    calendarTypeIsWithSchoolYear () {
      const typeHasSchoolYear = ['merge', 'other', 'kindergarten', 'club']
      return typeHasSchoolYear.indexOf(this.theCreateCalendarsType) > -1
    },
    activeSchool () {
      return this.$store.state.activeSchool
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    placeholderText () {
      switch (this.theCreateCalendarsType) {
        case 'room':
          return this.$t('vue2.createrooms.placeholder')
        case 'other':
          return this.$t('vue2.create_calendars.other_calendar_placeholder')
        case 'merge':
          return this.$t('vue2.createmerge.placeholder')
        case 'club':
          return 'Eks. SFO Mosehuset'
      }
    },
    showInactiveButton () {
      if (this.calendarsWithText.length < 1) {
        return true
      }
    },
    theCreateCalendarsType () {
      return eventbus.createCalendarsType
    },
    buttonText () {
      if (this.calendarsWithText.length < 1) {
        return this.$t('vue2.createusers.create')
      } else {
        let calendarsPluralized = this.calendarsWithText.length === 1 ? this.$t('vue2.createmerge.calendar') : this.$t('vue2.createmerge.calendars')
        if (this.theCreateCalendarsType === 'room') {
          calendarsPluralized = this.calendarsWithText.length === 1 ? this.$t('vue2.createrooms.room') : this.$t('vue2.createrooms.rooms')
        }
        return this.$t('vue2.createusers.create') + ' ' + this.calendarsWithText.length + ' ' + calendarsPluralized
      }
    }
  },
  watch: {
    theCreateCalendarsType () {
      if (this.theCreateCalendarsType) {
        this.setShowModal()
      }
    }
  },
  methods: {
    setShowModal () {
      this.showModal = true
      this.pushNewCalendar()
      this.pushNewCalendar()
      this.pushNewCalendar()
      setTimeout(() => {
        document.querySelector('.namefield').focus()
      }, 100)
    },
    setIsSameInputToFalse () {
      if (!this.someWithSameName) {
        return
      } else {
        this.someWithSameName = false
        this.calendars.forEach(obj => {
          obj.isSameName = false
        })
      }
    },
    setSameInput (klassName) {
      for (let i = 0; i < this.calendars.length; i++) {
        if (this.calendars[i].name !== '') {
          if (this.calendars[i].name === klassName) {
            this.calendars[i].isSameName = true
          }
        }
      }
    },
    checkForSameNameInCalendars () {
      let nbr = 0
      for (let i = 0; i < this.calendarsWithText.length; i++) {
        for (let j = 0; j < this.calendarsWithText.length; j++) {
          if (j !== i) {
            if (this.calendarsWithText[i].name === this.calendarsWithText[j].name) {
              this.setSameInput(this.calendarsWithText[i].name)
              nbr++
            }
          }
        }
      }
      if (nbr > 0) {
        this.someWithSameName = true
      } else {
        this.someWithSameName = false
      }
    },
    setCloseModal () {
      this.showModal = false
      eventbus.createCalendarsType = null
      this.calendars = []
      this.calendarsWithText = []
      this.someWithSameName = false
      this.openedFromRoRSelect2 = false
    },
    pushNewCalendar () {
      this.calendars.push({
        name: '',
        type: this.theCreateCalendarsType,
        isSameName: false
      })
      if (this.calendars.length > 4) {
        setTimeout(() => {
          this.scrollInDiv()
        }, 0)
      }
    },
    removeCalendar (cal) {
      this.calendars.splice(this.calendars.indexOf(cal), 1)
      this.setIsSameInputToFalse()
      this.checkForSameNameInCalendars()
      this.checkAllForText()
    },
    scrollInDiv () {
      var objDiv = document.querySelector('.modal-body')
      objDiv.scrollTop = objDiv.scrollHeight
    },
    checkAllForText ($event) {
      if ($event && $event.key === 'Escape') {
        this.setCloseModal()
      }
      this.setIsSameInputToFalse()
      this.calendarsWithText = []
      for (let i = 0; i < this.calendars.length; i++) {
        if (this.calendars[i].name.length > 0) {
          this.calendarsWithText.push(this.calendars[i])
        }
      }
      if (this.calendarsWithText.length === this.calendars.length) {
        this.pushNewCalendar()
      }
      this.checkForSameNameInCalendars()
    },
    submit () {
      let isOpenedFromRoRSelect2 = false
      // Check this.openedFromRoRSelect2 before this.setCloseModal()
      if (this.openedFromRoRSelect2) {
        isOpenedFromRoRSelect2 = true
      }
      this.checkForSameNameInCalendars()
      if (!this.someWithSameName) {
        eventbus.toast = {text: this.$t('vue2.createrooms.creating'), 'success': false}
        let calendarType = this.theCreateCalendarsType
        docendo.schoolBulkCreateCalendars(this.activeSchool.id, this.activeSchoolYear.id, this.calendarsWithText,
          success => {
            eventbus.toast = {text: this.$t('vue2.createmerge.succes_text'), 'success': true}
            this.$store.dispatch('getSchoolCalendars', this.activeSchool.id)
            // IF MERGE AND ONBOARDING
            if (calendarType === 'merge') {
              this.$store.dispatch('updateUserSettings', {'setup_widget_progress_merge': true})
              setTimeout(() => {
                this.$store.commit('setOnboardingStep', 0)
              }, 2500)
            }
            // IF ROOM AND ONBOARDING
            if (calendarType === 'room') {
              this.$store.dispatch('updateUserSettings', {'setup_widget_progress_rooms': true})
              setTimeout(() => {
                this.$store.commit('setOnboardingStep', 0)
              }, 2500)
              if (isOpenedFromRoRSelect2) {
                this.$helpers.sendCustomEvt('vue_created_room', success[0].calendarable_id)
              }
            }
            if (window.Intercom) {
              window.Intercom('trackEvent', 'Created calendars: ' + this.theCreateCalendarsType)
            }
          },
          errors => {
            eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
          }
        )
        this.setCloseModal()
      }
    }
  },
  mounted () {
    // Can also be opened from ROR select2-button
    window.addEventListener('vueCreateRoom', e => {
      this.openedFromRoRSelect2 = true
      this.calendars.push({
        name: e.detail,
        type: 'room',
        isSameName: false
      })
      eventbus.createRoomModal = true
      this.checkAllForText()
    }, false)
  }
}

</script>

<style scoped>
@import '../../assets/css/variables.css';

.cr-content {
  border: 1px solid #ccc;
  padding-top: 20px;
  background: #fff;
}

.modal-form-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 30px;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #999
}

.modal-form__titles {
  padding: 0 30px;
  margin-bottom: 10px;
}

.modal-form__titles > h3:nth-child(2) {
  padding-right: 20px;
}

.create-form {
  width: 98%;
  margin-top: 10px;
}

.modal-form-group > .delete__user {
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.modal-form-group > .delete__user:hover {
  background-color: #ffdcdc;
  border: 1px solid #d72b3f;
  color: #d72b3f;
}

.create-form:first-child {
  margin-top: 0;
}

.create-form:last-child {
  border-bottom: 0 !important;
}

.create-form > div {
  flex: 1;
}

.create-form > div:first-child,
.flex-1:first-child {
  margin-right: 5px;
}

.create-form > div:nth-child(2) {
  margin-left: 5px;
}

.create-form > div label {
  font-size: 10px;
}

.flex-end {
  justify-content: flex-end;
}

.add-more-button {
  padding: 10px 30px;
  color: var(--blue);
  font-size: 13px;
  cursor: pointer;
  display: inline-block;
}

.add-more-button:hover .add-more-button__text {
  text-decoration: underline;
}

.plus--icon {
  cursor: pointer;
  display: inline-flex;
  border: 2px solid var(--blue);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: space-around;
  font-weight: bold;
  font-size: 15px;
  padding-left: 1px;
  text-decoration: none !important;
}

.missing-input {
  border-color: red;
}

.warning-text {
  color: red;
}

.submit-btn--disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #f6f7f8 !important;
  border: 1px solid #d8d8d8 !important;
}

</style>



// WEBPACK FOOTER //
// CreateCalendars.vue?0a810f90